// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title_DQFOh","bold":"Title_bold_2htH5","strong":"Title_strong_1NL6f","heading":"Title_heading_2UKw7","legend":"Title_legend_3C_DX"};
    if(module.hot) {
      // 1789136764555
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  